import { bool, shape, string } from "prop-types";

export default {
  email: string,
  headshot_url: string,
  headshot_for_profile: string,
  url: string,
  id: string,
  industry_professional: shape({
    has_rental_manager_tool: bool,
    has_active_advertising_agreement: bool,
    is_invoice_user: bool,
    listing_provider: shape({
      id: string
    }),
    paid_inclusion: shape({
      is_exempt: bool,
      opted_in_at: string
    })
  }),
  name: string,
  phone: string
};
